import { getFeatureToggle } from "../../common/utils/get-feature-toggle";
import { useClientSettings } from "../../common/client-settings";
import { microserviceSettingsByName } from "../../common/constants";

export const useMicroserviceAvailable = (
  microserviceName: keyof typeof microserviceSettingsByName
) => {
  const { clientSettings } = useClientSettings();

  const {
    name,
    groupKey,
    systemId = undefined,
  } = microserviceSettingsByName[microserviceName];

  return getFeatureToggle(
    clientSettings?.settings ?? null,
    name,
    groupKey,
    systemId
  );
};
